import React, { useEffect, useState } from "react";
import "./PaymentIdCardModal.css";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import selectCorrectUrls from "../../selectCorrectUrls";
import { isMobile } from "react-device-detect";
import PuffLoader from "react-spinners/PuffLoader";
import { css } from "@emotion/react";

const PaymentIdCardModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [closeMultipleModal, setCloseMultipleModal] = useState(false);
  const [failed, setFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [multiplePoliciesFound, setMultiplePolicies] = useState(false);
  const [multiplePoliciesList, setMultiplePoliciesList] = useState("");
  const guestOptionReducer = useSelector((state) => state.guestOptionReducer);
  const guestCONRReducer = useSelector((state) => state.guestCONRReducer);
  const guestStateReducer = useSelector((state) => state.guestStateReducer);
  const guestshrtlnkReducer = useSelector((state) => state.guestshrtlnkReducer);
  const guestchoosenPolicyPrefixReducer = useSelector(
    (state) => state.guestchoosenPolicyPrefixReducer
  );
  const guestchoosenPolicyNoReducer = useSelector(
    (state) => state.guestchoosenPolicyNoReducer
  );

  const [shrtlnk, setShrtLnk] = useState("");

  const [selectedOption, setSelectedOption] = useState("policy");
  const [conr, SetCONR] = useState("");
  const [state, SetState] = useState("");
  const [formData, setFormData] = useState({
    number: "",
    zip: "",
    dob: "",
  });

  const override = css`
    display: flex;
    margin: auto;
    color: white;
    margin-top: -7px;
  `;
  useEffect(() => {
    resetAllData();
    if (!isOpen) {
      setSelectedOption("policy");
    }
  }, [selectedOption, !isOpen]);

  const maxAllowedDob = new Date();
  maxAllowedDob.setFullYear(maxAllowedDob.getFullYear() - 16);
  const maxDobStr = maxAllowedDob.toISOString().split("T")[0];

  const resetAllData = () => {
    setErrorMessage("");
    // setSelectedOption("policy");
    // Reset form data when selectedOption changes
    setFormData({
      number: "",
      zip: "",
      dob: "",
    });
    dispatch({
      type: "SET_SHORT_LINK",
      payload: "",
    });
    dispatch({
      type: "SET_GUEST_CONR",
      payload: "",
    });
    dispatch({
      type: "SET_GUEST_STATE",
      payload: "",
    });
    setMultiplePolicies(false);
    setMultiplePoliciesList("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  const [config, setConfig] = useState({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "text",
  });

  useEffect(() => {
    console.log("guestCONRReducer -->", guestCONRReducer);
  }, [guestCONRReducer]);
  useEffect(() => {
    console.log("guestStateReducer -->", guestStateReducer);
  }, [guestStateReducer]);

  useEffect(() => {
    if (formData.zip.length === 5) {
      getCONRfromZipCode();
    }
  }, [formData.zip]);

  useEffect(() => {
    if (formData.number.length > 1) {
      validatePolicy(guestCONRReducer);
    }
  }, [guestCONRReducer]);

  const getCONRfromZipCode = () => {
    console.log("getCONRfromZipCode");
    let submitformdata = new FormData();
    if (formData.zip.length === 5) {
      submitformdata.append("mailingZip", formData.zip);
    }
    let url = `${
      selectCorrectUrls().quotePortal
    }/insurednew/insured/insuredpayment/checkstate`;

    axios
      .post(url, submitformdata, config)
      .then((response) => {
        console.log("response", response);

        const state = response?.data?.trim?.();
        if (!state) return;

        // map state to CONR codes
        const stateMap = {
          FL: "01",
          TX: "08",
          GA: "10",
        };

        if (stateMap[state]) {
          dispatch({
            type: "SET_GUEST_CONR",
            payload: stateMap[state],
          });
          dispatch({
            type: "SET_GUEST_STATE",
            payload: state,
          });
        }

        // now runs for ALL states, not just GA
        if (formData?.number?.length > 1) {
          validatePolicy(guestCONRReducer);
        }
      })
      .catch((error) => {
        console.error("axios error:", error);
      });
  };

  // Escape key handler
  const handleEsc = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      console.log("🚪 Escape key pressed — closing");
      onClose(); // Run your close function
    }
  };

  // Attach handler on mount
  useEffect(() => {
    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []); // Empty array → runs once on mount

  // window.addEventListener("keydown", handleEsc);

  const validatePolicy = (companyNo) => {
    console.log("VALIDATE THE POLICY");
    let submitformdata = new FormData();
    if (formData.zip.length === 5 && formData.number.length > 1) {
      submitformdata.append("CONR", `${companyNo}`);

      let url = "";

      if (selectedOption === "dl" && companyNo !== "") {
        url = `${
          selectCorrectUrls().quotePortal
        }/insurednew/insured/insuredpayment/driverlicenselookup`;
        submitformdata.append("licenseNumber", formData.number); // fixed space here
      } else if (selectedOption === "policy" && companyNo !== "") {
        url = `${
          selectCorrectUrls().quotePortal
        }/insurednew/insured/insuredpayment/policylookup`;
        submitformdata.append("policyNumber", formData.number);
      } else {
        console.warn("Unknown selectedOption:", selectedOption);
        return; // exit early if invalid option
      }

      axios
        .post(url, submitformdata, config)
        .then((response) => {
          if (Array.isArray(response.data)) {
            console.log(response.data);
            setMultiplePolicies(true);
            setCloseMultipleModal(false);
            setMultiplePoliciesList(response.data);
          } else {
            const trimmedData = response.data.trim();
            const [prefix, policyNo] = trimmedData?.split("|");

            if (prefix !== "" && policyNo !== "") {
              setMultiplePolicies(false);

              dispatch({
                type: "SET_CHOSEN_PRFX",
                payload: prefix,
              });
              dispatch({
                type: "SET_CHOSEN_PLN",
                payload: policyNo,
              });
            }
          }

          // handle response here if needed
        })
        .catch((e) => {
          console.log("ERRORRR", e);
        });
    }
  };
  const continueAsGuest = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let submitformdata = new FormData();

    let url = `${
      selectCorrectUrls().quotePortal
    }/insurednew/insured/insuredpayment/insuredpaymentguest`;

    submitformdata.append("source", "INS");
    submitformdata.append("TRANSFLG", "P");
    submitformdata.append("CONR", guestCONRReducer);
    submitformdata.append("SITE_STATE", guestStateReducer);
    submitformdata.append("mailingZip", `${formData.zip}`);
    submitformdata.append("policy-or-dl", `${selectedOption}`);
    submitformdata.append("policyordl", `${formData.number}`);
    submitformdata.append("tbxMM", `${formData.dob.split("-")[1]}`);
    submitformdata.append("tbxDD", `${formData.dob.split("-")[2]}`);
    submitformdata.append("tbxYY", `${formData.dob.split("-")[0]}`);

    submitformdata.append(
      "choosenPolicyPrefix",
      `${guestchoosenPolicyPrefixReducer}`
    );
    submitformdata.append("choosenPolicyNo", `${guestchoosenPolicyNoReducer}`);

    if (selectedOption === "dl") {
      submitformdata.append("FLAG", `N`);
      submitformdata.append("tbxDOB", `${formData.dob.replaceAll("-", "")}`);
      submitformdata.append(
        "state",
        `${guestStateReducer}|${guestCONRReducer}`
      );
    }
    submitformdata.append("view", `${guestOptionReducer}`);
    submitformdata.append("sysType", isMobile ? "M" : "");

    axios
      .post(url, submitformdata, config)
      .then((response) => {
        console.log("✅ continueAsGuest response.data", response.data);
        setIsLoading(false);
        if (!response.data.error) {
          const status = response?.data?.status;
          const URL = response?.data?.url;

          if (status) {
            const tempForm = document.createElement("form");
            tempForm.method = "POST";
            tempForm.action = `${
              selectCorrectUrls().insuredPortal
            }/insurednew/${URL}`;
            tempForm.enctype = "application/x-www-form-urlencoded";
            tempForm.target = "_blank"; // or "_blank" to test in new tab
            tempForm.style.display = "none";

            for (let [key, value] of submitformdata.entries()) {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = value;
              tempForm.appendChild(input);
            }

            document.body.appendChild(tempForm);

            // Add a real submit button just to test
            const submitBtn = document.createElement("button");
            submitBtn.type = "submit";
            submitBtn.innerText = "Submit Now";
            tempForm.appendChild(submitBtn);

            setTimeout(() => {
              console.log("tempForm", tempForm);
              submitBtn.click(); // or test manually
            }, 1000); // ensure the form is in DOM
          }
        } else {
          dispatch({ type: "SET_SHORT_LINK", payload: "" });
          setErrorMessage(response.data.error);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.log("❌ Initial validation error:", e);
        setErrorMessage("Initial validation failed.");
      });
  };

  const multiplePolicyModal = () => {
    return (
      <>
        <div
          className="modal-overlay"
          style={{ display: closeMultipleModal ? "none" : "" }}
        >
          <div className="modal-box">
            <div className="modal-header1">
              <div className="heading-wrapper" style={{ width: "100%" }}>
                <h2>Please select one below:</h2>
                <div
                  style={{ width: "33%", marginTop: "6px" }}
                  className="underline-bar"
                ></div>
              </div>
              <button
                className="close-button"
                onClick={() => {
                  setCloseMultipleModal(true);
                }}
              >
                ×
              </button>
            </div>
            {/* <p
              style={{
                fontWeight: "bold",
                marinLeft: "22%",
                marginBottom: "5px",
              }}
            >
              Please select one below:
            </p> */}
            <ul style={{ marginLeft: "22%" }}>
              {multiplePoliciesList &&
                multiplePoliciesList.map((policy, index) => {
                  let prefix = policy.split("-");
                  let number = prefix[1].split("(")[0];
                  return (
                    <li
                      key={index}
                      style={{ padding: "5px" }}
                      onClick={() => {
                        dispatch({
                          type: "SET_CHOSEN_PRFX",
                          payload: prefix[0],
                        });
                        dispatch({
                          type: "SET_CHOSEN_PLN",
                          payload: number,
                        });
                        setCloseMultipleModal(true);
                      }}
                    >
                      {policy}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </>
    );
  };
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-box">
          <div className="modal-header1">
            <p></p>
            <div className="heading-wrapper">
              <h2>
                {guestOptionReducer === "Payment"
                  ? "Make Payment "
                  : "Get ID Card "}{" "}
                as Guest
              </h2>
              <div className="underline-bar"></div>
            </div>
            <button className="close-button" onClick={onClose}>
              ×
            </button>
          </div>

          <form
            // actiononSubmit={handleSubmit}
            // action={guestshrtlnkReducer}
            // name="guestForm"
            // id="guestForm"
            // method="POST"
            className="modal-form"
          >
            <div className="form-group">
              <label>
                <span className="text-danger">*</span> Choose Policy or D/L
                Number
              </label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="option"
                    value="policy"
                    checked={selectedOption === "policy"}
                    onChange={() => setSelectedOption("policy")}
                  />
                  <span className="custom-radio"></span>
                  Policy #
                </label>
                <label>
                  <input
                    type="radio"
                    name="option"
                    value="dl"
                    checked={selectedOption === "dl"}
                    onChange={() => setSelectedOption("dl")}
                  />
                  <span className="custom-radio"></span>
                  Driver's License #
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>
                <span className="text-danger">*</span> Enter{" "}
                {selectedOption === "dl" ? "Driver License" : "Policy"} Number
              </label>
              <input
                type="text"
                name="number"
                placeholder={`Enter ${
                  selectedOption === "dl" ? "D/L" : "Policy"
                } Number`}
                value={formData.number}
                onChange={(e) => {
                  handleChange(e);
                }}
                onKeyDown={() => {
                  setErrorMessage("");
                  dispatch({
                    type: "SET_SHORT_LINK",
                    payload: "",
                  });
                }}
                required
              />
            </div>
            <div className="form-group">
              <label>
                <span className="text-danger">*</span> Mailing Zip Code
              </label>
              <input
                type="text"
                name="zip"
                placeholder="Enter Zip Code"
                value={formData.zip}
                maxLength={5}
                onKeyDown={(e) => {
                  setErrorMessage("");
                  dispatch({
                    type: "SET_SHORT_LINK",
                    payload: "",
                  });
                  const isLetterOrNumber = /^[0-9]$/.test(e.key); // Only digits
                  const allowedControlKeys = [
                    "Backspace",
                    "Tab",
                    "ArrowLeft",
                    "ArrowRight",
                    "Delete",
                  ];

                  const isPasteCombo =
                    (e.ctrlKey || e.metaKey) && e.key === "v";

                  if (
                    !isLetterOrNumber &&
                    !allowedControlKeys.includes(e.key) &&
                    !isPasteCombo
                  ) {
                    e.preventDefault(); // Block everything else
                  }
                }}
                onChange={(e) => {
                  handleChange(e);
                }}
                required
              />
            </div>
            <div className="form-group">
              <label>
                <span className="text-danger">*</span> Date of Birth
              </label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={(e) => {
                  handleChange(e);
                }}
                onKeyDown={() => {
                  setErrorMessage("");
                  dispatch({
                    type: "SET_SHORT_LINK",
                    payload: "",
                  });
                }}
                required
                min="1995-01-01"
                max={
                  new Date(
                    new Date().setFullYear(new Date().getFullYear() - 16)
                  )
                    .toISOString()
                    .split("T")[0]
                }
              />{" "}
              {new Date(formData.dob) > new Date(maxDobStr) && (
                <span
                  style={{ color: "red", fontWeight: "500", fontSize: "14px" }}
                >
                  *Please enter valid year of birth
                </span>
              )}
            </div>
            {errorMessage !== "" ? (
              <center>
                {" "}
                <span style={{ fontWeight: "bold", color: "red" }}>
                  {errorMessage}
                </span>
              </center>
            ) : (
              ""
            )}

            <button
              // type="submit"
              className="submit-button"
              disabled={
                formData.number === "" ||
                formData.zip.length !== 5 ||
                !formData.dob ||
                formData.dob < "1925-01-01" ||
                formData.dob >= maxDobStr
              }
              onClick={(e) => {
                e.preventDefault(); // optional but safe
                if (
                  formData.dob >= "1925-01-01" &&
                  formData.dob <= maxDobStr &&
                  formData.zip.length === 5 &&
                  formData.number !== ""
                ) {
                  continueAsGuest(e);
                }
              }}
            >
              {isLoading ? (
                <div>
                  <PuffLoader color={"white"} css={override} size={30} />
                </div>
              ) : (
                "Continue"
              )}
            </button>
          </form>
        </div>
      </div>
      {multiplePoliciesFound && multiplePolicyModal()}
    </>
  );
};

export default PaymentIdCardModal;
